import { flattenTree } from 'react-accessible-treeview';
let idCounter = 0;
const generatedIds = new Set<string>();
const recPrepare = (itemsArray: unknown[]) => {
  const res: any[] = [];
  let childrenCount = 0;

  itemsArray.forEach((item: any) => {
    if (generatedIds.has(item.id)) {
      return;
    }
    idCounter += 1;
    const uniqueId = `node-${idCounter}`;
    generatedIds.add(uniqueId);
    childrenCount = 0;
    const children = item.children.length ? recPrepare(item.children) : [];
    // @ts-ignore
    children?.itemsArray?.forEach((item1: any) => {
      childrenCount = childrenCount + item1.metadata.count + 1;
    });
    res.push({
      id: uniqueId,
      name: uniqueId,
      metadata: {
        ...item,
        count: childrenCount,
      },
      // @ts-ignore
      children: children?.itemsArray,
    });
  });
  return { itemsArray: res, count: childrenCount };
};
const getDataForTree = (array: any[]) => {
  idCounter = 0;
  generatedIds.clear();
  return flattenTree({
    name: 'getDataForTreeName',
    children: recPrepare(array).itemsArray,
  });
};

export default getDataForTree;
